<template>
    <div class="event-selector">
        <div class="event-selector-toolbar">
            <div class="field">
                <label>{{ $t("automation.automationName") }}: </label>
                <a-input v-model="automationName" :placeholder="$t('automation.automationName')" />
            </div>

            <div class="field">
                <label>{{ $t("automation.supsisObject") }}: </label>
                <a-select v-model="selectedModule" :placeholder="$t('automation.supsisObject')">
                    <a-select-option v-for="module in modules" :key="module" :value="module">
                        {{ module }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <a-divider />
        <SupsisTable
            :columns="getCols()"
            :rows="getEvents()"
            top-pagination
            empty-data-bordered
            bottom-pagination
            :pagination-cursor="pagination"
            :options="{
                checkboxOption,
                rowStyleOption,
                clipboardOption,
                fixedHeader: true,
                id: 'events-table',
                borderX: true,
                borderY: true,
            }"
            @cursor-changed="(cursor) => (pagination = cursor)"
        />
    </div>
</template>
<script>
import Vue from "vue";
import SupsisTable from "../../../../components/SupsisTable.vue";
import moment from "moment";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "EventSelector",
    components: { SupsisTable, SupsisButton },
    props: {
        defaultModule: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            automationName: "Untitled Automation 🚀",
            selectedModule: this.defaultModule || "all",
            selectedEvent: null,
            modules: [
                "all",
                "chat",
                "contact",
                "tag",
                "email",
                "task",
                "event",
                "form",
                "meta-lead",
                "agent",
                "invoice",
                "whatsapp",
                "reservation",
                "chatbot",
                "webhook",
                "table",
                "ticket",
                "calendar",
            ].filter((module) => module === this.defaultModule || !this.defaultModule),
            events: [
                {
                    module: "form",
                    event: "form.submitted",
                    implemented: true,
                    description: this.$t("When a form is submitted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "calendar",
                    event: "calendar.event_created",
                    implemented: true,
                    description: this.$t("automation.calendarEventCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "calendar",
                    event: "calendar.event_updated",
                    implemented: true,
                    description: this.$t("automation.calendarEventUpdated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "calendar",
                    event: "calendar.event_deleted",
                    implemented: true,
                    description: this.$t("automation.calendarEventDeleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "calendar",
                    event: "calendar.reservation_created",
                    implemented: true,
                    description: this.$t("automation.reservationCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "calendar",
                    event: "calendar.reservation_date_changed",
                    implemented: true,
                    description: this.$t("automation.reservationDateChanged"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "calendar",
                    event: "calendar.reservation_deleted",
                    implemented: true,
                    description: this.$t("automation.reservationDeleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "table",
                    event: "table.record_created",
                    implemented: true,
                    description: this.$t("automation.whenRecordCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "table",
                    event: "table.record_updated",
                    implemented: true,
                    description: this.$t("automation.whenRecordUpdated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "table",
                    event: "table.record_deleted",
                    implemented: true,
                    description: this.$t("automation.whenRecordDelete"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "table",
                    event: "table.record_automation_button_clicked",
                    implemented: true,
                    description: this.$t("automation.whenRecordAutomation"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "message",
                    event: "message.picked",
                    implemented: true,
                    description: this.$t("automation.whenMessagePicked"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "webhook",
                    event: "webhook.catch",
                    implemented: false,
                    description: this.$t("automation.whenWebhookTriggered"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.created",
                    implemented: true,
                    description: this.$t("automation.whenChatCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.closed",
                    implemented: true,
                    description: this.$t("automation.whenChatClosed"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.rated",
                    implemented: true,
                    description: this.$t("automation.whenChatRated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                //chat.lost
                {
                    module: "chat",
                    event: "chat.lost",
                    implemented: true,
                    description: this.$t("automation.chatLost"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                //chat.webchat_completed etc.... instagram,facebook,messenger,whatsapp,telegram
                {
                    module: "chat",
                    event: "chat.webchat_completed",
                    implemented: true,
                    description: this.$t("automation.webchatCompleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.instagram_complated",
                    implemented: true,
                    description: this.$t("automation.instagramCompleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.messenger_complated",
                    implemented: true,
                    description: this.$t("automation.messengerCompleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.whatsapp_complated",
                    implemented: true,
                    description: this.$t("automation.whatsappCompleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.telegram_complated",
                    implemented: true,
                    description: this.$t("automation.telegramCompleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                //chat.assigned_to_agent
                {
                    module: "chat",
                    event: "chat.assigned_to_agent",
                    implemented: true,
                    description: this.$t("automation.chatAssignedToAgent"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },

                {
                    module: "contact",
                    event: "contact.created",
                    implemented: true,
                    description: this.$t("automation.whenNewContactCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "contact",
                    event: "contact.updated",
                    implemented: true,
                    description: this.$t("automation.whenContactUpdate"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "contact",
                    event: "contact.contact-property-updated",
                    implemented: true,
                    description: this.$t("automation.whenContactPropUpdate"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "contact",
                    event: "contact.tag-added",
                    implemented: true,
                    description: this.$t("automation.whenNewTagAdded"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "contact",
                    event: "contact.tag-removed",
                    implemented: true,
                    description: this.$t("automation.whenTagRemoved"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                //contact.profile_button_clicked
                {
                    module: "contact",
                    event: "contact.profile_button_clicked",
                    implemented: true,
                    description: this.$t("automation.profileButtonClicked"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "email",
                    event: "email.received",
                    implemented: true,
                    description: this.$t("automation.whenNewEmailReceived"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.created",
                    implemented: true,
                    description: this.$t("automation.whenNewTaskCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },

                {
                    module: "task",
                    event: "task.completed",
                    implemented: true,
                    description: this.$t("automation.whenTaskCompleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.deleted",
                    implemented: true,
                    description: this.$t("automation.whenTaskDeleted"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.assignee-changed",
                    implemented: true,
                    description: this.$t("automation.whenTaskAssigneeChanged"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.priority-changed",
                    implemented: true,
                    description: this.$t("automation.whenTaskPriorityChanged"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.due-date-changed",
                    implemented: true,
                    description: this.$t("automation.whenTaskDueDateChanged"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.stage-changed",
                    implemented: true,
                    description: this.$t("automation.whenTaskStatusChanged"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.archived",
                    implemented: true,
                    description: this.$t("automation.whenTaskArchived"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.tag-added",
                    implemented: true,
                    description: this.$t("automation.whenTagAdded"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.tag-removed",
                    implemented: true,
                    description: this.$t("automation.whenTagRemovedTask"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.checklist-completed",
                    implemented: true,
                    description: this.$t("automation.whenTagChecklist"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.reminder-activated",
                    implemented: false,
                    description: this.$t("automation.whenReminderActivated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "ticket",
                    event: "ticket.created",
                    implemented: true,
                    description: this.$t("automation.whenTicketCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "ticket",
                    event: "ticket.stage-changed",
                    implemented: true,
                    description: this.$t("automation.whenTicketStageChanged"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "ticket",
                    event: "ticket.assignee-changed",
                    implemented: true,
                    description: this.$t("automation.whenTicketAssigneeChanged"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "ticket",
                    event: "ticket.closed",
                    implemented: true,
                    description: this.$t("automation.whenTicketClosed"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "ticket",
                    event: "ticket.updated",
                    implemented: true,
                    description: this.$t("automation.whenTicketUpdated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "meta-lead",
                    event: "meta-lead.created",
                    implemented: false,
                    description: this.$t("automation.whenNewMetaleadCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "agent",
                    event: "agent.created",
                    implemented: false,
                    description: this.$t("automation.whenNewAgentCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "invoice",
                    event: "invoice.created",
                    implemented: false,
                    description: this.$t("automation.whenNewInvoiceCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "whatsapp",
                    event: "whatsapp.message-received",
                    implemented: false,
                    description: this.$t("automation.whenNewWpReceived"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "reservation",
                    event: "reservation.created",
                    implemented: false,
                    description: this.$t("automation.whenNewReservationCreated"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chatbot",
                    event: "chatbot.message-received",
                    implemented: false,
                    description: this.$t("automation. whenNewChatbotReceived"),
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
            ],
            checkboxOption: {
                selectedRowKeys: [],
                // row select change event
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    console.log("selectedRowChange", { row, isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
                // selected all change event
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    console.log("selectedAllChange", { isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
            },
            rowStyleOption: {
                stripe: true,
            },
            clipboardOption: {
                copy: true,
                paste: false,
                cut: false,
                delete: false,
            },
            pagination: {
                page: 1,
                perPage: 20,
                total: 0,
                defaultPageSize: 50,
                hideOnSinglePage: true,
                pageSizeOptions: [10, 15, 20, 50, 100],
                showQuickJumper: true,
                showSizeChanger: true,
            },
        };
    },
    methods: {
        save() {
            const meta = this.events.find((event) => event.event === this.selectedEvent);
            this.$emit("save", {
                name: this.automationName,
                event: this.selectedEvent,
                payload: meta.payload,
            });
        },
        selectEvent(event) {
            this.selectedEvent = event;
            this.save();
        },
        getCols() {
            return [
                {
                    key: "module",
                    field: "module",
                    title: this.$t("message.module"),
                    width: "",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.module}</span>;
                    },
                },
                {
                    key: "Event",
                    field: "event",
                    title: this.$t("report.event"),
                    width: "",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.event}</span>;
                    },
                },

                {
                    key: "description",
                    field: `description`,
                    title: this.$t("message.description"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.description}</span>;
                    },
                },
                {
                    key: "implemented",
                    field: "implemented",
                    title: this.$t("message.implemented"),
                    width: "120px",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.implemented ? (
                            <a-icon type="check-circle" style="color: green; font-size: 20px;" />
                        ) : (
                            <a-icon type="close-circle" style="color: red; font-size: 20px;" />
                        );
                    },
                },
                {
                    title: this.$t("message.action"),
                    key: "operation",
                    width: "100px",
                    align: "center",
                    operationColumn: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div class="actions">
                                <SupsisButton onClick={() => this.selectEvent(row.event)} ghost primary>
                                    { this.$t("chatbotv2.select")}
                                </SupsisButton>
                            </div>
                        );
                    },
                },
            ];
        },
        getEvents() {
            return this.events.filter((event) => {
                if (this.selectedModule) {
                    return this.selectedModule === "all" || event.module === this.selectedModule;
                }
                return true;
            });
        },
    },
    watch: {
        selectedModule() {
            this.pagination.page = 1;
            if (this.automationName.includes("Untitled")) {
                this.automationName = `Untitled Automation 🚀`;
            }
        },
    },
});
</script>

<style scoped lang="scss">
.event-selector {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .event-selector-toolbar {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;

        .field {
            display: flex;
            align-items: baseline;
            gap: 5px;
        }

        label {
            font-weight: 700;
            font-size: 16px;
        }

        .ant-select {
            width: 200px;
        }
    }
}
</style>
